import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { ITenderClientPOC } from "./Tender_Client_POC";

interface IProps {
  singleData: ITenderClientPOC;
  open: boolean;
  hideDialog: () => void;
  toast: any;
}

export const TenderClientDetails = (props: IProps) => {
  const [tableData, setTableData] = useState<{ tableData: any[]; loading: boolean }>({ tableData: [], loading: false });
  const onHide = () => {
    props.hideDialog();
  };

  const loadTableData = async (clientID: number) => {
    try {
      setTableData((prev: any) => ({ ...prev, loading: true }));

      const response = await Fetch("Tender_POC_Mast/getClientDetails", "GET", null, `clientID=${clientID}`, props.toast);

      if (response?.ok) {
        const data = await response.json();
        setTableData({ tableData: data, loading: false });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTableData((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    if (props.open && props.singleData.vendor_Company_ID) {
      loadTableData(props.singleData.vendor_Company_ID);
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, props.singleData]);

  return (
    <Dialog visible={props.open} style={{ width: "80vw" }} header="Client Details" modal className="p-fluid" onHide={onHide}>
      <DataTable value={tableData.tableData} loading={tableData.loading} showGridlines stripedRows header="RFP Client">
        <Column header="SN." body={(data, options) => options.rowIndex + 1} />
        <Column field="category_Name" header="Category" />
        <Column field="client_Name" header="Contact Name" />
        <Column field="vendor_Company_Name" header="Client Company" />
        <Column field="service_Department" header="Department" />
        {/* <Column field="service_Location" header="Location" /> */}
      </DataTable>
    </Dialog>
  );
};
